import { useEffect, useMemo, useState } from 'react';
import { AudioController } from './components/AudioController';
import { FloatingNav } from './components/FloatingNav';
import { birthdayConfig } from './config';
import { useLocalStorage } from './hooks/useLocalStorage';
import { CouponsSection } from './sections/CouponsSection';
import { DinnerPlannerSection } from './sections/DinnerPlannerSection';
import { FinalSurpriseSection } from './sections/FinalSurpriseSection';
import { HeroSection } from './sections/HeroSection';
import { HotelsSection } from './sections/HotelsSection';
import { LetterSection } from './sections/LetterSection';
import { LoveGameSection } from './sections/LoveGameSection';
import { MemoriesSection } from './sections/MemoriesSection';
import { OpeningOverlay } from './sections/OpeningOverlay';
import { ReasonsSection } from './sections/ReasonsSection';
import { ToursSection } from './sections/ToursSection';

export default function App() {
  const [openingVisible, setOpeningVisible] = useState(() => sessionStorage.getItem('birthday-audio-started') !== 'true');
  const [selectedHotelId, setSelectedHotelId] = useLocalStorage('birthday-selected-hotel', '');
  const [selectedTourId, setSelectedTourId] = useLocalStorage('birthday-selected-tour', '');

  const selectedHotel = useMemo(() => birthdayConfig.hotels.find((hotel) => hotel.id === selectedHotelId) ?? null, [selectedHotelId]);
  const selectedTour = useMemo(() => birthdayConfig.tours.find((tour) => tour.id === selectedTourId) ?? null, [selectedTourId]);

  useEffect(() => {
    document.title = birthdayConfig.site.title;
    document.documentElement.style.setProperty('--primary', birthdayConfig.theme.primaryColor);
    document.documentElement.style.setProperty('--secondary', birthdayConfig.theme.secondaryColor);
    document.documentElement.style.setProperty('--accent', birthdayConfig.theme.accentColor);
  }, []);

  return (
    <div className="app-shell">
      <OpeningOverlay open={openingVisible} onOpen={() => setOpeningVisible(false)} />
      {!openingVisible && <>
        <FloatingNav />
        <AudioController />
      </>}
      <main aria-hidden={openingVisible}>
        <HeroSection effectsActive={!openingVisible} />
        <LetterSection />
        <LoveGameSection />
        <MemoriesSection />
        <ReasonsSection />
        <DinnerPlannerSection selectedHotel={selectedHotel} />
        <HotelsSection selectedHotelId={selectedHotelId} onSelectHotel={setSelectedHotelId} />
        <ToursSection selectedTourId={selectedTourId} onSelectTour={setSelectedTourId} />
        <CouponsSection />
        <FinalSurpriseSection
          selectedHotel={selectedHotel}
          selectedTour={selectedTour}
          onReplay={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            window.setTimeout(() => setOpeningVisible(true), 450);
          }}
        />
      </main>
    </div>
  );
}
